/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  permission.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { asyncRouterMap, constantRouterMap } from "@/config/router.config";
import {generateMenu, MenuRoute} from "@/utils/permissionUtil";

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    menuData: [],
  },
  mutations: {
    SET_ROUTERS: (state: any, routers: any) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_MENU_DATA: (state: any, menuData: any) => {
      state.menuData = menuData;
    },
  },
  actions: {
    GenerateRoutes({ commit }: any, data: any) {
      return new Promise<void>((resolve) => {
        let { menus } = data;
        menus = menus ? [menus] : [];
        const mainRes = generateMenu({
          // @ts-ignore
          routes: constantRouterMap,
          menus,
        });
        commit("SET_ROUTERS", mainRes.routes);
        commit("SET_MENU_DATA", mainRes.menuData);
        resolve();
      });
    },
  },
};

export default permission;
